import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/lib/constants";
import { Loader2, RefreshCw } from "lucide-react";

export const NewerPostsPill = ({ onRefresh, loading, lastFetchedAt, feedType }) => {
  const [hasNew, setHasNew] = useState(false);

  useEffect(() => {
    if (!lastFetchedAt) return;
    let active = true;
    const checkForNew = async () => {
      try {
        const params = feedType ? `?type=${feedType}` : "";
        const res = await axios.get(`${API}/topics/latest-timestamp${params}`);
        const latest = res.data.latest;
        if (active && latest && latest > lastFetchedAt) setHasNew(true);
      } catch {}
    };
    const interval = setInterval(checkForNew, 30000);
    const timeout = setTimeout(checkForNew, 5000);
    return () => { active = false; clearInterval(interval); clearTimeout(timeout); };
  }, [lastFetchedAt, feedType]);

  useEffect(() => { if (loading) setHasNew(false); }, [loading]);

  if (!hasNew) return null;

  return (
    <button
      onClick={() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        const checkScroll = () => { if (window.scrollY < 10) { onRefresh?.(); } else { requestAnimationFrame(checkScroll); } };
        requestAnimationFrame(checkScroll);
      }}
      disabled={loading}
      data-testid="newer-posts-btn"
      className="fixed top-14 lg:top-12 right-4 z-50 flex items-center gap-2 px-4 py-2 bg-jeekota-primary text-white rounded-full shadow-lg hover:bg-jeekota-primary/90 transition-all animate-in slide-in-from-right-4 duration-300"
    >
      {loading ? <Loader2 size={16} className="animate-spin" /> : <RefreshCw size={16} />}
      <span className="text-sm font-medium">New Posts Available</span>
    </button>
  );
};
